module.exports = __webpack_public_path__ + "img/8006.0b47767f.gif";